// extracted by mini-css-extract-plugin
export var adjacentSlide = "_j8-9";
export var arrowButtonContainer = "_j8-5";
export var arrowButtonIcon = "_j8-6";
export var carouselArrowButton = "_j8-2";
export var carouselElementContainer = "_j8-1";
export var currentSlide = "_j8-8";
export var left = "_j8-3";
export var otherSlide = "_j8-a";
export var productCarouselContainer = "_j8-0";
export var right = "_j8-4";
export var sliderOverflow = "_j8-7";